import React from "react";

import {  injectIntl } from "react-intl";

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';
import { Formik } from "formik";

import TGrid from "../../partials/content/Grid";
import { editAccountStatus } from "../../crud/auth.crud";

import 'date-fns';




const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
};





class EditAccountStatus extends React.Component {
  state = {
    
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    selDate:new Date('2014-08-18T21:11:54'),
    statusList:{},
  }



  


constructor(props)
{
  super(props);
    this.state = {
      menu: false,
     
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      locading:false,
      statusColor:'alert-success',
 
      
    };

    


    
  
}
  
  
  handleChangeComplete = (color) => {
    this.setState({ background: color.hex });
  };

  componentDidMount()
  {
    
    if(this.props.location.data.status!=null)
    {

      console.log("status:::",this.props.location.data.status);
      this.setState({statusList:this.props.location.data.status});
      this.setState({background:this.props.location.data.status.statusId});
    }
     
  }

  



  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;
    return (
      <>

          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}
          {this.state.statusList!=null &&
           <Formik
                  initialValues={{
                    statusKey:this.state.statusList.statusKey,
                    statusName:this.state.statusList.statusName,
                    statusDescription:this.state.statusList.statusDescription,
                  }}
                  validate={values => {
                    const errors = {};
            
                    

                    if (!values.statusDescription) {
                      errors.statusDescription = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting ,setFieldValue}) => {
                    this.setState({loading:true});
                    let tStatus = {
                    statusKey:this.state.statusList.statusKey,
                    statusName : values.statusDescription,
                    statusDescription : values.statusDescription
                  }
                    editAccountStatus(
                      tStatus
                    )
                      .then(resp => {
                        //props.register(accessToken);
                        this.setState({status:true,
                        statusMessage:'Status updated successfully',
                        alertType:'alert-success',loading:false});
                         window.scrollTo(0,0);
                        
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
          
                      
        	
      		<TGrid beforeCodeTitle="Basic Details" jsCode="false">
        	<div className="kt-section">
	        	<div className="kt-section__content">
           

		   			
		   			<div className="row">
		   			          

                           

                      <div className="col-12">
                        <TextField
                          margin="normal"
                          label="Description"
                          className="kt-width-full"
                          name="statusDescription"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.statusDescription}
                          helperText={touched.statusDescription && errors.statusDescription}
                          error={Boolean(touched.statusDescription && errors.statusDescription)}
                        />
                      </div>      
       
                      
		   			  </div>
             
             
				   
			    </div>
		    </div>
		    </TGrid>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                           Update
                        </button>
                      </div>
       </form>
            )}
            </Formik>
          }
       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(EditAccountStatus));

